// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".styles-module__message__29OA8{padding:10px 0;background:#ffc107;color:#000;font-size:15px;position:relative}\n", ""]);
// Exports
exports.locals = {
	"message": "styles-module__message__29OA8"
};
module.exports = exports;
